<div class="m-question default d-flex flex-column m-question-{{qID}}" [attr.data-qid]="qID"
	[ngClass]="{
		'edit': (qID==parentComponent.editQid || qID===parentComponent.editQuestion)?((isAfterStep1 && isActiveStep1)?false:true):false,
		'read-only': parentComponent.isVisible(qID) 
	}">
	<div class="dev_qid">#{{qID}}</div>  <!-- debug -->
	<div class="m-question-content">
		<ng-content></ng-content>
	</div>
	<div class="m-question-action text-center text-md-right m-4" *ngIf="parentComponent.visibleQids && (parentComponent.editQid!=qID) && !questionnaireService.isActiveEditQuestion">
		<button *ngIf="isAfterStep1 === false && isActiveStep1 || isAfterStep1 && isActiveStep1 ===false" type="button" class="button app-button button-secondery" (click)="edit(qID);">
			<i class="fa fa-pencil px-1" aria-hidden="true"></i>{{"COMMON.EDIT" | translate}}
		</button>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/question/question.component.html